export const AUTH_LINK_VARIANTS = {
    SIGN_IN: 'sign-in',
    SIGN_UP: 'sign-up',
} as const;

export type AuthLinkVariant = (typeof AUTH_LINK_VARIANTS)[keyof typeof AUTH_LINK_VARIANTS];
